import React, { useState, useEffect, useRef } from 'react';
import LeaseApiService from '../../../services/apiService';
import { RiRefreshLine } from 'react-icons/ri';
import { ClipLoader } from 'react-spinners';
import { getName } from '../../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaSave, FaChevronLeft, FaEdit, FaTrash } from 'react-icons/fa';
import UnitDetailsEdt from './unitDetails';
import moment from 'moment';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { HashLoader } from 'react-spinners';
import 'react-datepicker/dist/react-datepicker.css';
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';
import PaymentInvoices from '../paymentList';

const EditLeaseAgrement = () => {
  const apiService = new LeaseApiService();
  const userName = useSelector(getName);
  const [loading, setloader] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const { currencyPrecision } = useCurrency();
  const [FilterTab, setFilterTab] = useState(true);
  const [loader, setLoader] = useState(true);
  const [tentantTab, setTanantTab] = useState(false);
  const [tentantJoint, setTanantJoint] = useState(false);
  const [periodFrom, setPeriodFrom] = useState('');
  const [periodTo, setPeriodTo] = useState('');
  const [leaseTerm, setLeaseTerm] = useState('');
  const [rentFreeFrom, setRentFreeFrom] = useState('');
  const [rentFreeTo, setRentFreeTo] = useState('');
  const [rentFreeDays, setRentFreeDays] = useState('');
  const [isKanooCompany] = useState(() => {
    const DB = localStorage.getItem('DataBase');
    const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
    const defaultCompany = companies.find((comp) => comp.dataDB === DB);
    const companyName = defaultCompany?.companyName?.toLowerCase() || '';
    return companyName.includes('accountcode') || companyName.includes('kanoo') || companyName.includes('bh');
  });
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [propertylist, setPropertyList] = useState([]);
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [customerList, setCUstomerList] = useState([]);
  const [leasingAgent, setLeasingAgent] = useState([]);
  const [remarksList, setRemarksList] = useState([]);
  const [deletedUnit, setDeletedUnit] = useState([]);
  const [additionalCharges, setAdditionalCharges] = useState([]);
  const [unitData, setUntData] = useState();
  const [InvoiceList, setInvoiceList] = useState([]);
  const gridRef = useRef();
  const location = useLocation();
  const leaseData = location.state;
  const navigate = useNavigate();
  const [editIndex, setEditIndex] = useState(null);
  const [dataList, setDataList] = useState([
    {
      Property: [],
      Unit: [],
      noCommunity: '',
      rentPerAnum: '',
      unitClass: '',
      type: '',
      rentForPeriod: '',
      rentAmount: '',
      unitRefNo: '',
      bedRooms: '',
      FreeRent: '',
      discountPerc: '',
      totalArea: '',
      Landloard: '',
      taxCode: [],
      category: '',
      vat: '',
      discount: '',
      total: '',
      parkingNo: '',
      munAcNo: '',
      Parking: '',
      taxRate: '',
    },
  ]);
  const [formData, setFormData] = useState({
    vatRecord: '',
    Property: [],
    Unit: [],
    noCommunity: '',
    rentPerAnum: '',
    unitClass: '',
    type: '',
    rentForPeriod: '',
    unitRefNo: '',
    bedRooms: '',
    FreeRent: '',
    discountPerc: '',
    totalArea: '',
    Landloard: '',
    taxCode: [],
    category: '',
    vat: '',
    discount: '',
    total: '',
    parkingNo: '',
    munAcNo: '',
    Parking: '',
    taxRate: '',
  });
  const [transData, setTransData] = useState({
    transectionDate: '',
    periodFrom: '',
    periodTo: '',
    noInstallment: '',
    CustomerName: '',
    CustomerAccount: '',
    leaseAgent: '',
    JointCustomerName: '',
    JointCustomerAccount: '',
    Broker: '',
    remarks: '',
    remarks2: '',
    arabicRemarks: '',
  });
  const totalRent = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentForPeriod) || 0), 0).toFixed(currencyPrecision?.decimalNumbers || 2);
  const totalVat = dataList?.reduce((sum, row) => sum + (parseFloat(row?.vat) || 0), 0).toFixed(currencyPrecision?.decimalNumbers || 2);
  const rentPerAnum = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentPerAnum) || 0), 0).toFixed(currencyPrecision?.decimalNumbers || 2);
  const totalDiscount = dataList?.reduce((sum, row) => sum + (parseFloat(row?.FreeRent) || 0), 0).toFixed(currencyPrecision?.decimalNumbers || 2);
  const calculatedTotal = dataList?.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0).toFixed(currencyPrecision?.decimalNumbers || 2);

  useEffect(() => {
    getUserList();
  }, [leaseData]);

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const calculateDaysDifference = (from, to) => {
    const fromDate = new Date(from);
    const toDate = new Date(to);

    fromDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);

    return Math.floor((toDate - fromDate) / (1000 * 60 * 60 * 24)) + 1;
  };
  const calculate30360Days = (from, to) => {
    const fromDate = new Date(from);
    const toDate = new Date(to);
    toDate.setDate(toDate.getDate() + 1);

    const yearFrom = fromDate.getFullYear();
    const yearTo = toDate.getFullYear();
    const monthFrom = fromDate.getMonth() + 1;
    const monthTo = toDate.getMonth() + 1;
    const dayFrom = fromDate.getDate();
    const dayTo = toDate.getDate();

    let adjustment = 0;
    if (dayFrom === 31) {
      adjustment = 1;
    } else if (dayTo === 31 && (dayFrom === 30 || dayFrom === 31)) {
      adjustment = 1;
    }

    return (yearTo - yearFrom) * 360 + (monthTo - monthFrom) * 30 + (dayTo - dayFrom) - adjustment;
  };
  useEffect(() => {
    const today = new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);
    nextYear.setDate(nextYear.getDate() - 1);
    const formattedToday = today.toISOString().split('T')[0];
    const formattedNextYear = nextYear.toISOString().split('T')[0];

    setPeriodFrom(formattedToday);
    setPeriodTo(formattedNextYear);
    setTransData({
      transectionDate: formattedToday,
      periodFrom: formattedToday,
      periodTo: formattedNextYear,
      leaseTerm: calculateDaysDifference(formattedToday, formattedNextYear),
    });
    setLeaseTerm(calculateDaysDifference(formattedToday, formattedNextYear));
  }, []);
  const getUserList = async () => {
    try {
      setLoader(true);
      const params = new URLSearchParams();
      params.append('dropdownTypes', 'LASerPropertyName,LACustomerName,LALeasingAgent,LALeaseRemarks,VatPercentage');
      const customerRes = await apiService.getApiParamater('GET_PROPERT_DROP', `?${params?.toString()}`);
      setCUstomerList(customerRes?.data?.dropdowns?.LACustomerName);
      setPropertyList(customerRes?.data?.dropdowns?.LASerPropertyName);
      setLeasingAgent(customerRes?.data?.dropdowns?.LALeasingAgent);
      setRemarksList(customerRes?.data?.dropdowns?.LALeaseRemarks);
      setTaxCodeList(customerRes?.data?.dropdowns?.VatPercentage);
      if (leaseData) {
        const leaseDataParam = new URLSearchParams();
        leaseDataParam.append('Action', 'getLeaseDetailsById');
        leaseDataParam.append('GroupId', leaseData?.groupId);
        const leaseDataRes = await apiService.getApiParamater('GET_UNITNO_DATA', `?${leaseDataParam?.toString()}`);
        let leaseResData = '';
        if (leaseDataRes?.data?.result?.data?.length > 0) {
          let leaseResponse = leaseDataRes?.data?.result?.data[0];
          leaseResData = leaseResponse;
        } else {
          let leaseResponse = leaseDataRes?.data?.result?.data;
          leaseResData = leaseResponse;
        }
        const additionalChargesParam = new URLSearchParams();
        additionalChargesParam.append('Action', 'getLeaseAdditionalDetailsById');
        additionalChargesParam.append('GroupId', leaseData?.groupId);
        const additionalChargesRes = await apiService.getApiParamater('GET_UNITNO_DATA', `?${additionalChargesParam?.toString()}`);
        let AdditionalChargesData = additionalChargesRes?.data?.result?.data;
        if (AdditionalChargesData?.length > 0) {
          const updatedData = AdditionalChargesData.map((item) => ({
            ...item,
            isSelected: !!item?.RecordId,
          }));
          setAdditionalCharges(updatedData);
        } else if (AdditionalChargesData?.Description) {
          const singleItem = {
            ...AdditionalChargesData,
            isSelected: !!AdditionalChargesData?.RecordId,
          };
          setAdditionalCharges([singleItem]);
        } else {
          const additionalParam = new URLSearchParams();
          additionalParam.append('Action', 'GetChargesDetails');
          additionalParam.append('RentPerAnnum', leaseData?.rentPerYear);
          const Additionalres = await apiService.getApiParamater('GET_UNITNO_DATA', `?${additionalParam?.toString()}`);
          setAdditionalCharges(Additionalres?.data?.result?.data);
        }
        // broker = agent
        const selectedAgent = customerRes?.data?.dropdowns?.LALeasingAgent?.find((pro) => pro?.value === leaseResData?.Agent);
        // Leasing Agent = salesperson
        const SalesPerson = customerRes?.data?.dropdowns?.LALeasingAgent?.find((pro) => pro?.value === leaseResData?.SalesPerson);
        const Cust1 = customerRes?.data?.dropdowns?.LACustomerName?.find((pro) => pro?.value === leaseResData?.Cust1_No);
        const Cust2 = customerRes?.data?.dropdowns?.LACustomerName?.find((pro) => pro?.value === leaseResData?.Cust2_No);
        const remarks = customerRes?.data?.dropdowns?.LALeaseRemarks?.find((pro) => pro?.text === leaseResData?.Remarks);
        const taxCode = customerRes?.data?.dropdowns?.VatPercentage?.find((pro) => parseInt(pro?.value) === leaseResData?.Tax_Code);
        // Cust no 1
        const cust1params = new URLSearchParams();
        cust1params.append('Action', 'GetCustomerDetailsByTenantNo');
        cust1params.append('TenantNo', leaseResData?.Cust1_No);
        const cust1res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${cust1params.toString()}`);
        // Cust no 2
        const params = new URLSearchParams();
        params.append('Action', 'GetCustomerDetailsByTenantNo');
        params.append('TenantNo', leaseResData?.Cust2_No);
        const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
        let leaseterm = calculateDaysDifference(leaseResData?.Lease_Date, leaseResData?.Lease_Expiry);
        setTransData({
          ...transData,
          transectionDate: moment(leaseResData?.TransactionDate).toDate(),
          periodFrom: moment(leaseResData?.Lease_Date, 'DD-MM-YYYY').toDate(),
          periodTo: moment(leaseResData?.Lease_Expiry, 'DD-MM-YYYY').toDate(),
          noInstallment: leaseResData?.PaymentTermNoOfChqs,
          leaseAgent: { label: SalesPerson?.value || '', value: SalesPerson?.text || '' },
          Broker: { label: selectedAgent?.value || '', value: selectedAgent?.text || '' },
          CustomerName: { label: Cust1?.text || '', value: Cust1?.value || '' },
          CustomerAccount: { label: Cust1?.value || '', value: cust1res?.data?.result?.data || '' },
          JointCustomerName: { label: Cust2?.text || '', value: Cust2?.value || '' },
          JointCustomerAccount: { label: Cust2?.value || '', value: res?.data?.result?.data || '' },
          remarks: { label: remarks?.value || '', value: remarks?.text || '' },
          remarks2: remarks?.text,
          arabicRemarks: leaseResData?.RentPI_Remarks,
          leaseTerm: leaseterm,
        });
        setPeriodFrom(moment(leaseResData?.Lease_Date).format('YYYY-MM-DD'));
        setPeriodTo(moment(leaseResData?.Lease_Expiry).format('YYYY-MM-DD'));
        setLeaseTerm(leaseterm);
        if (leaseResData?.Exp15) {
          setRentFreeFrom(moment(leaseResData?.Exp15).format('YYYY-MM-DD'));
        }
        if (leaseResData?.Exp16) {
          setRentFreeTo(moment(leaseResData?.Exp16).format('YYYY-MM-DD'));
        }
        if (leaseResData?.RentFreeDays) {
          setRentFreeDays(leaseResData?.RentFreeDays);
        }

        if (leaseDataRes?.data?.result?.data?.length > 0) {
          const formattedEntry = leaseDataRes?.data?.result?.data?.map((item, index) => ({
            Property: {
              value: item.Property_Id || '', // → property_Id
              label: item.Property_Name || '', // → propertyName
            },
            Unit: {
              value: item.Unit_No || '', // → unitNo
              label: item.Unit_No || '',
            },
            vatRecord: item?.Tax_Code,
            noCommunity: '',
            rentPerAnum: item?.Rent_Per_Annum?.toFixed(currencyPrecision?.decimalNumbers),
            unitClass: item?.UnitClass,
            type: item?.Unit_Type,
            rentForPeriod: item?.Rent?.toFixed(currencyPrecision?.decimalNumbers),
            unitRefNo: item?.UnitRefNo,
            bedRooms: item?.Bedrooms,
            totalArea: item?.Total_Area,
            Landloard: item?.Landlord,
            rentAmount: item?.Rent - item?.Discount,
            taxCode: { label: taxCode?.text, value: taxCode?.value },
            category: item?.Unit_Category,
            vat: item?.VAT,
            FreeRent: item?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
            discount: item?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
            total: item?.Total?.toFixed(currencyPrecision?.decimalNumbers),
            parkingNo: item?.ParkingNo,
            munAcNo: item?.MuncAcNo,
            MunicipalityNo: item?.MunicipalityNo,
            Parking: item?.Parking,
            taxRate: item?.TaxPercent || 0,
            discountPerc: item?.DiscountPercent || 0,
            discount: item?.Discount?.toFixed(currencyPrecision?.decimalNumbers) || 0,
            vatRecord: item?.TaxCode,
          }));
          setDataList(formattedEntry);
        } else {
          const formattedEntry = {
            Property: {
              value: leaseResData.Property_Id || '', // → property_Id
              label: leaseResData.Property_Name || '', // → propertyName
            },
            Unit: {
              value: leaseResData.Unit_No || '', // → unitNo
              label: leaseResData.Unit_No || '',
            },
            vatRecord: leaseResData?.Tax_Code,
            noCommunity: '',
            rentAmount: leaseResData?.Rent - leaseResData?.Discount,
            rentPerAnum: leaseResData?.Rent_Per_Annum?.toFixed(currencyPrecision?.decimalNumbers),
            unitClass: leaseResData?.UnitClass,
            type: leaseResData?.Unit_Type,
            rentForPeriod: leaseResData?.Rent?.toFixed(currencyPrecision?.decimalNumbers),
            unitRefNo: leaseResData?.UnitRefNo,
            bedRooms: leaseResData?.Bedrooms,
            totalArea: leaseResData?.Total_Area,
            Landloard: leaseResData?.Landlord,
            taxCode: { label: taxCode?.text, value: taxCode?.value },
            category: leaseResData?.Unit_Category,
            vat: leaseResData?.VAT,
            FreeRent: leaseResData?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
            discount: leaseResData?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
            total: leaseResData?.Total?.toFixed(currencyPrecision?.decimalNumbers),
            parkingNo: leaseResData?.ParkingNo,
            munAcNo: leaseResData?.MuncAcNo,
            MunicipalityNo: leaseResData?.MunicipalityNo,
            Parking: leaseResData?.Parking,
            taxRate: leaseResData?.TaxPercent || 0,
            discountPerc: leaseResData?.DiscountPercent || 0,
            discount: leaseResData?.Discount?.toFixed(currencyPrecision?.decimalNumbers) || 0,
            vatRecord: leaseResData?.TaxCode,
          };
          setDataList([formattedEntry]);
        }
        handlePaymentPlan(leaseData);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error('Error fetching data:', error?.customerRes?.data?.message);
    }
  };
  const handleclearform = () => {
    setFormData({
      Property: [],
      Unit: [],
      noCommunity: '',
      rentPerAnum: '',
      unitClass: '',
      type: '',
      rentForPeriod: '',
      unitRefNo: '',
      bedRooms: '',
      FreeRent: '',
      discountPerc: '',
      totalArea: '',
      Landloard: '',
      taxCode: [],
      category: '',
      vat: '',
      discount: '',
      total: '',
      parkingNo: '',
      munAcNo: '',
      Parking: '',
    });
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleSave = async () => {
    try {
      setloader(true);
      if (!transData?.noInstallment) {
        toast.warning(`Please Enter No of Installment`);
        setloader(false);
        return;
      }
      // else if (!transData?.remarks2) {
      //     toast.warning(`Please Select Remarks`);
      //     setloader(false);
      //     return;
      // }
      else if (!transData?.CustomerAccount?.label) {
        toast.warning(`Please Select Primary Tenant`);
        setloader(false);
        return;
        // } else if (!transData?.leaseAgent?.label) {
        //     toast.warning(`Please Select Lease Agent`);
        //     setloader(false);
        //     return;
      }
      //  else if (!transData?.remarks2) {
      //     toast.warning(`Please Enter Remarks`);
      //     setloader(false);
      //     return;
      // }
      const periodYear = new Date(periodFrom).getFullYear();
      const leaseYear = new Date(leaseData?.leaseStart).getFullYear();
      if (periodYear !== leaseYear) {
        toast.warning(`Lease start year cannot be changed.`);
        setloader(false);
        return;
      }

      const currentDatetimeUTC = new Date().toISOString();
      const unitDetailsList = await Promise.all(
        dataList.map(async (item) => {
          const validation = new URLSearchParams();
          validation.append('Action', 'CheckAgreementValidPeriodEdit');
          validation.append('PeriodFrom', periodFrom);
          validation.append('PeriodTo', periodTo);
          // validation.append("PropertyName", item?.Property?.label);
          validation.append('PropertyNo', item?.Property?.value);
          validation.append('UnitNo', item?.Unit?.label);
          validation.append('GroupId', leaseData?.groupId);
          validation.append('UnitRefNo', item?.unitRefNo);

          // const validRes = await apiService.getApiParamater(
          //     "GET_UNITNO_DATA",
          //     `?${validation?.toString()}`
          // );

          // if (validRes?.data?.result?.data?.Count > 0) {
          //     toast.warning(
          //         `Selected Unit ${item?.Unit?.label} Already Existed in lease Aggrement, in Given ${transData?.periodFrom} to ${transData?.periodTo}`
          //     );
          //     return null;
          // }

          return {
            recordId: leaseData?.recordId,
            leaseNo: leaseData?.leaseNo,
            groupId: leaseData?.groupId,
            proposalNo: '0',
            propertyNo: item?.Property?.value,
            propertyName: item?.Property?.label,
            unitNo: item?.Unit?.label,
            unitRefNo: item?.unitRefNo,
            unitClass: item?.unitClass,
            totalArea: parseFloat(item?.totalArea),
            rentPerAnnum: parseFloat(item?.rentPerAnum),
            periodRent: parseFloat(item?.rentForPeriod),
            discountPercent: parseFloat(item?.discountPerc) || 0,
            discount: parseFloat(item?.FreeRent) || 0,
            rent: parseFloat(item?.rentForPeriod),
            vat: parseFloat(item?.vat),
            total: parseFloat(item?.total),
            taxCode: parseInt(item?.vatRecord),
            taxPercent: parseFloat(item?.taxRate),
            landlord: item?.Landloard,
            municipalityNo: item?.munAcNo,
            createdBy: userName,
            createdOn: currentDatetimeUTC,
            isAdded: true,
            isUpdated: false,
            rentNL: false,
          };
        }),
      );

      const formattedRows = unitDetailsList.filter(Boolean);
      if (formattedRows.length === 0) {
        toast.warning(`Please Select Unit to Update Lease Aggrement`);
        setloader(false);
        return;
      }
      const selectedAdditional = additionalCharges?.filter((acc) => acc.isSelected === true && parseFloat(acc?.Total) > 0);

      const additionalChargesList = selectedAdditional.map((item, index) => ({
        recordId: leaseData?.recordId,
        leaseNo: leaseData?.leaseNo,
        groupId: leaseData?.groupId,
        description: item?.Description,
        mId: item?.MId,
        drAcCode: item?.DrAcCode || transData?.CustomerAccount?.label || '0',
        drAcName: item?.DrAcName || transData?.CustomerName?.label || '0',
        crAcCode: item?.CrAcCode || '0',
        crAcName: item?.CrAcName || '0',
        taxCode: item?.TaxCode,
        taxInclusive: item?.TaxInclusive,
        amount: item?.Amount,
        vat: item?.VAT,
        total: item?.Total,
        remarks: item?.Remarks,
        posting: !!item?.Posting,
        isDeposit: !!item?.IsDeposit,
        status: '0',
        psdId: 0,
        propertyNo: dataList[0]?.Property?.value,
        propertyName: dataList[0]?.Property?.label,
        unitNo: dataList[0]?.Unit?.label,
        unitRefNo: dataList[0]?.unitRefNo,
        tenantNo: transData?.CustomerAccount?.label,
        tenantName: transData?.CustomerName?.label,
        category: '',
        receiptNo: '0',
        receiptDate: currentDatetimeUTC,
        voucherNo: '0',
        voucherDate: currentDatetimeUTC,
        financialYear: 'FY 2025',
        exp1: '0',
        exp2: '0',
        exp3: '0',
        exp4: '0',
        exp5: '0',
        modifiedBy: userName,
        modifiedOn: currentDatetimeUTC,
        createdBy: userName,
        createdOn: currentDatetimeUTC,
        vatDescription: item?.VATDescription || '0',
        isChecked: true,
      }));
      const leaseAgreementMaster = {
        recordId: leaseData?.recordId,
        leaseNo: leaseData?.leaseNo,
        group_Id: leaseData?.groupId,
        leaseDate: periodFrom,
        leaseExpiry: periodTo,
        status: '0',
        tenantNo: transData?.CustomerAccount?.label,
        tenantName: transData?.CustomerName?.label,
        tenantTradeName: '',
        tenantBrand: '',
        totalArea: 0,
        totalAmount: 0,
        totalAmountByUser: 0,
        leaseTerm: leaseTerm?.toString(),
        leaseTermInMonths: parseInt(transData?.leaseTerm / 30),
        paymentTerm: '',
        paymentTermNoOfChqs: transData?.noInstallment,
        discountPercent: 0,
        discount: 0,
        taxCode: 0,
        taxInclusive: false,
        vatPercent: 0,
        stPercent: 0,
        st: 0,
        vat: 0,
        rent: 0,
        total: 0,
        modifiedBy: userName,
        modifiedOn: currentDatetimeUTC,
        createdBy: userName,
        createdOn: currentDatetimeUTC,
        transactionDate: transData?.transectionDate,
        rentFreeDays: rentFreeDays || 0,
        rentFreeAmount: parseFloat(totalDiscount) || 0,
        exp15: rentFreeFrom?.toString() || '',
        exp16: rentFreeTo?.toString() || '',
        remarks: transData?.remarks2 || '',
        arabicRemarks: transData?.arabicRemarks || '',
        leasingAgent: transData?.leaseAgent?.label || '',
        brokerName: transData?.Broker?.label || '',
        outletName: '',
      };
      const body = {
        leaseMain: {
          leaseAgreementMaster: leaseAgreementMaster,
          unitDetailsList: formattedRows,
          additionalChargesList: additionalChargesList,
          custPri_ContactNo: transData?.CustomerAccount?.value?.ContactNo?.toString() || '',
          custPri_Email: transData?.CustomerAccount?.value?.Email || '',
          custPri_PassportID: transData?.CustomerAccount?.value?.IDNo?.toString() || '',
          custPri_Nationality: transData?.CustomerAccount?.value?.Nationality?.toString() || '',
          custPri_VatRegNo: transData?.CustomerAccount?.value?.VATRegNo?.toString() || '',
          custJoint_CustNo: transData?.JointCustomerAccount?.label || '',
          custJoint_CustName: transData?.JointCustomerName?.label || '',
          custJoint_ContactNo: transData?.JointCustomerAccount?.value?.ContactNo?.toString() || '',
          custJoint_Email: transData?.JointCustomerAccount?.value?.Email || '',
          custJoint_PassportID: transData?.JointCustomerAccount?.value?.IDNo?.toString() || '',
          custJoint_Nationality: transData?.JointCustomerAccount?.value?.Nationality?.toString() || '',
          custJoint_VatRegNo: transData?.JointCustomerAccount?.value?.VATRegNo?.toString() || '',
        },
        deletedUnitsList: deletedUnit,
      };

      const postRes = await apiService.post('EDIT_LEASE_AGRE', body);
      if (postRes?.data?.statusCode === 201) {
        // const token = localStorage.getItem("Token");
        // const DB = localStorage.getItem("DataBase")
        // if (!token) {
        //     alert("Auth token is missing! Unable to proceed.");
        //     return;
        // }
        // const popupWidth = 1000;
        // const popupHeight = 600;
        // const popupLeft = (window.screen.width - popupWidth) / 2;
        // const popupTop = (window.screen.height - popupHeight) / 2;
        // const popup = window.open(
        //     "",
        //     "ReportPopup",
        //     `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
        // );

        // if (popup) {
        //     const form = document.createElement("form");
        //     form.method = "POST";
        //     form.action =
        //         "https://procreports.pro360dev.freemyip.com/RDLReport/WebForm/ProcurementReports.aspx";
        //     form.target = "ReportPopup";

        //     const inputs = [
        //         { name: "authToken", value: token },
        //         { name: "_db", value: "PMK4000" },
        //         { name: "reportName", value: "LSESTMT" },
        //         { name: "voucherNo", value: postRes?.data?.result?.leaseNo },
        //     ];

        //     inputs.forEach(({ name, value }) => {
        //         const input = document.createElement("input");
        //         input.type = "hidden";
        //         input.name = name;
        //         input.value = value;
        //         form.appendChild(input);
        //     });

        //     document.body.appendChild(form);
        //     form.submit();
        //     document.body.removeChild(form);
        // }
        toast.success(`${postRes?.data?.result?.leaseNo} Created successfully`);
        setloader(false);
        navigate('/Property/Management/LeaseAgreement');
      }
      setloader(false);
    } catch (error) {
      setloader(false);

      console.error('Error Save Data', error);
    }
  };
  const handlePeriodToChange = ({ name, value }) => {
    const newToDate = value;
    if (new Date(newToDate) <= new Date(periodFrom)) {
      toast.warning('Period To date cannot be earlier than Period From date.');
      return;
    }
    const formattedDate = formatDate(newToDate);
    setPeriodTo(formattedDate);
    setLeaseTerm(calculateDaysDifference(periodFrom, formattedDate));
  };
  const handlePeriodFromChange = ({ name, value }) => {
    const newFromDate = value;
    const newToDate = new Date(newFromDate - 1);
    newToDate.setFullYear(newToDate.getFullYear() + 1);

    const formattedFrom = formatDate(newFromDate);
    const formattedTo = formatDate(newToDate);

    const nextYear = new Date(newFromDate);
    nextYear.setFullYear(newFromDate.getFullYear() + 1);
    nextYear.setDate(nextYear.getDate() - 1);
    const formattedToday = newFromDate.toISOString().split('T')[0];
    const formattedNextYear = nextYear.toISOString().split('T')[0];

    setPeriodFrom(formattedFrom);
    setPeriodTo(formattedNextYear);
    setLeaseTerm(calculateDaysDifference(formattedFrom, formattedNextYear));
  };
  const handleRentFreeFromChange = ({ name, value }) => {
    if (rentFreeTo && new Date(value) > new Date(rentFreeTo)) {
      toast.warning('Rent Free From date cannot be later than Rent Free To date.');
      return;
    }
    if (periodFrom && periodTo && (new Date(value) < new Date(periodFrom) || new Date(value) > new Date(periodTo))) {
      toast.warning('Rent Free From date must be between Period From and Period To.');
      return;
    }
    const formattedFrom = formatDate(value);
    setRentFreeFrom(formattedFrom);
    if (rentFreeTo) {
      setRentFreeDays(
        isKanooCompany ? calculate30360Days(formattedFrom, rentFreeTo) : calculateDaysDifference(formattedFrom, rentFreeTo)
      );
    }
  };
  const handleRentFreeToChange = ({ name, value }) => {
    if (rentFreeFrom && new Date(value) < new Date(rentFreeFrom)) {
      toast.warning('Rent Free To date cannot be earlier than Rent Free From date.');
      return;
    }
    if (periodFrom && periodTo && (new Date(value) < new Date(periodFrom) || new Date(value) > new Date(periodTo))) {
      toast.warning('Rent Free To date must be between Period From and Period To.');
      return;
    }
    const formattedTo = formatDate(value);
    setRentFreeTo(formattedTo);
    if (rentFreeFrom) {
      setRentFreeDays(
        isKanooCompany ? calculate30360Days(rentFreeFrom, formattedTo) : calculateDaysDifference(rentFreeFrom, formattedTo)
      );
    }
  };
  const handleInputChange = ({ name, value }) => {
    if (name === 'transectionDate') {
      if (new Date(value) > new Date(periodFrom)) {
        toast.warning(`Transaction Date should be earlier than Period From`);
        return;
      }
      setTransData({ ...transData, [name]: formatDate(value) });
    }
    setTransData({ ...transData, [name]: value });
  };
  const handlefieldChange = (e) => {
    const { name, value } = e.target;
    if (name === 'noInstallment') {
      if (value < 1) {
        toast.warning('No of Installment must be grater then or equal to "1');
        return;
      }
      if (dataList?.length > 0) {
        handleUnitPaymentPlan(dataList, value);
      }
    }
    setTransData({ ...transData, [e.target.name]: e.target.value });
  };
  const handleCustomer = async (selectedOption) => {
    if (transData?.JointCustomerName?.label === selectedOption?.label) {
      toast?.warning(`Primary Customer Should be Different from Joint `);
      return;
    } else {
      const params = new URLSearchParams();
      params.append('Action', 'GetCustomerDetailsByTenantNo');
      params.append('TenantNo', selectedOption?.value);
      const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
      setTransData({
        ...transData,
        CustomerName: selectedOption,
        CustomerAccount: { label: selectedOption?.value, value: res?.data?.result?.data },
      });
    }
  };
  const handleCustomerAccount = async (selectedOption) => {
    if (transData?.JointCustomerAccount?.label === selectedOption?.label) {
      toast?.warning(`Primary Customer Should be Different from Joint `);
      return;
    } else {
      const params = new URLSearchParams();
      params.append('Action', 'GetCustomerDetailsByTenantNo');
      params.append('TenantNo', selectedOption?.label);
      const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
      setTransData({
        ...transData,
        CustomerAccount: { label: selectedOption?.label, value: res?.data?.result?.data },
        CustomerName: { label: selectedOption?.value, value: selectedOption?.label },
      });
    }
  };
  const handleJointCustomer = async (selectedOption) => {
    if (transData?.CustomerName?.label === selectedOption?.label) {
      toast?.warning(`Joint Customer Should be Different from Primary`);
      return;
    } else {
      const params = new URLSearchParams();
      params.append('Action', 'GetCustomerDetailsByTenantNo');
      params.append('TenantNo', selectedOption?.value);
      const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
      setTransData({
        ...transData,
        JointCustomerName: selectedOption,
        JointCustomerAccount: { label: selectedOption?.value, value: res?.data?.result?.data },
      });
    }
  };
  const handleJointCustomerAccount = async (selectedOption) => {
    if (transData?.CustomerAccount?.label === selectedOption?.label) {
      toast?.warning(`Joint Customer Should be Different from Primary`);
      return;
    } else {
      const params = new URLSearchParams();
      params.append('Action', 'GetCustomerDetailsByTenantNo');
      params.append('TenantNo', selectedOption?.label);
      const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
      setTransData({
        ...transData,
        JointCustomerAccount: { label: selectedOption?.label, value: res?.data?.result?.data },
        JointCustomerName: { label: selectedOption?.value, value: selectedOption?.label },
      });
    }
  };
  const handleAgentChange = (selectedOption) => {
    setTransData({
      ...transData,
      leaseAgent: selectedOption,
    });
  };
  const handleBrokerChange = (selectedOption) => {
    setTransData({
      ...transData,
      Broker: selectedOption,
    });
  };
  const handleRemarksChange = (selectedOption) => {
    setTransData({
      ...transData,
      remarks: selectedOption,
      remarks2: selectedOption?.value,
    });
  };
  const handleCheckboxChange = async (index, field, value) => {
    const updated = [...additionalCharges];
    updated[index][field] = value;
    let data = updated[index];
    // If it's the select checkbox, also manage isSelected
    if (field === 'isSelected') {
      updated[index].isSelected = value;
    }
    if (field === 'Rate') {
      let qty = parseFloat(data?.Qty) || 0;
      let vatdes = data?.VATDescription;
      let amount = parseFloat(value) * qty;
      if (vatdes) {
        const taxParam = new URLSearchParams();
        taxParam.append('Action', 'GetTaxRecordIdByTaxName');
        taxParam.append('TaxDescription', vatdes);
        const taxrecord = await apiService.getApiParamater('GET_UNITNO_DATA', `?${taxParam.toString()}`);
        const result = taxrecord?.data?.result?.data;
        let VATRate = result?.Rate || 0; // Save VAT % for future calc
        const vat = (parseFloat(amount || 0) * VATRate) / 100;
        let VAT = vat;
        let Total = parseFloat(amount || 0) + vat;
        updated[index].Rate = value;
        updated[index].VATRate = VATRate || 0;
        updated[index].VAT = VAT;
        updated[index].Amount = amount;
        updated[index].Total = Total;
      } else {
        const vat = (parseFloat(amount || 0) * 0) / 100;
        let VAT = vat;
        let Total = parseFloat(amount || 0) + vat;
        updated[index].Rate = value?.toFixed(currencyPrecision?.decimalNumbers);
        updated[index].Amount = amount;
        updated[index].Total = Total;
      }
    }
    if (field === 'Qty') {
      let rate = parseFloat(data?.Rate) || 0;
      let vatdes = data?.VATDescription;
      let amount = parseFloat(value) * rate;
      if (vatdes) {
        const taxParam = new URLSearchParams();
        taxParam.append('Action', 'GetTaxRecordIdByTaxName');
        taxParam.append('TaxDescription', vatdes);
        const taxrecord = await apiService.getApiParamater('GET_UNITNO_DATA', `?${taxParam.toString()}`);
        const result = taxrecord?.data?.result?.data;
        let VATRate = result?.Rate || 0; // Save VAT % for future calc
        const vat = (parseFloat(amount || 0) * VATRate) / 100;
        let VAT = vat;
        let Total = parseFloat(amount || 0) + vat;
        updated[index].Qty = value;
        updated[index].VATRate = VATRate;
        updated[index].VAT = VAT;
        updated[index].Amount = amount;
        updated[index].Total = Total;
      } else {
        const vat = (parseFloat(amount || 0) * 0) / 100;
        let VAT = vat?.toFixed(currencyPrecision?.decimalNumbers);
        let Total = parseFloat(amount || 0) + vat;
        updated[index].Qty = value;
        updated[index].Amount = amount;
        updated[index].VAT = VAT;
        updated[index].Total = Total;
      }
    }
    setAdditionalCharges(updated);
  };
  const handleVatChange = async (index, taxCode) => {
    const selectedOption = taxCodeList.find((tc) => tc.value === taxCode);
    if (!selectedOption) return;
    const taxParam = new URLSearchParams();
    taxParam.append('Action', 'GetTaxRecordIdByTaxName');
    taxParam.append('TaxDescription', selectedOption.text);

    try {
      const taxrecord = await apiService.getApiParamater('GET_COMMON_PROP', `?${taxParam.toString()}`);
      const result = taxrecord?.data?.result?.data;

      if (result) {
        setAdditionalCharges((prev) => {
          const updated = [...prev];
          const row = { ...updated[index] };

          row.TaxCodeValue = taxCode;
          row.VATDescription = selectedOption.text;
          row.VATRate = result.Rate; // Save VAT % for future calc

          const vat = (parseFloat(row.Amount || 0) * result.Rate) / 100;
          row.VAT = vat;
          row.Total = parseFloat(row.Amount || 0) + vat;
          row.TaxCode = parseInt(taxCode);
          debugger;
          updated[index] = row;
          return updated;
        });
      }
    } catch (error) {
      console.error('Failed to fetch VAT data:', error);
    }
  };
  const preventNegativeSign = (e) => {
    if (e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };
  const handlePaymentPlan = async (rowData) => {
    const params = new URLSearchParams();
    params.append('Action', 'GetPaymentSchedule');
    params.append('LeaseNo', rowData?.leaseNo);
    const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params?.toString()}`);
    const planData = res?.data?.result?.data;
    setInvoiceList(planData == null ? [] : planData);
  };

  const handleUnitPaymentPlan = async (rowData, value) => {
    const leaseRows = rowData?.length > 0 ? rowData : [rowData];
    const totalRent = leaseRows?.reduce((sum, row) => sum + (parseFloat(row?.rentAmount) || 0), 0);
    const total = leaseRows?.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0);
    const vat = leaseRows?.reduce((sum, row) => sum + (parseFloat(row?.vat) || 0), 0);
    // comma separated values
    const propertyNos = [...new Set(leaseRows.map((i) => i.Property?.value).filter(Boolean))].join(',');
    const propertyNames = [...new Set(leaseRows.map((i) => i.Property?.label).filter(Boolean))].join(',');
    const unitNos = [...new Set(leaseRows.map((i) => i.Unit?.label).filter(Boolean))].join(',');
    const taxCodes = [...new Set(leaseRows.map((i) => i.taxCode?.value).filter(Boolean))].join(',');
    const taxPercents = [...new Set(leaseRows.map((i) => i.taxRate).filter((v) => v !== undefined))].join(',');

    const params = new URLSearchParams();
    params.append('PropertyNo', propertyNos);
    params.append('PropertyName', propertyNames);
    params.append('UnitNo', unitNos);
    params.append('TaxCode', leaseRows[0]?.taxCode?.value);
    params.append('VATPercent', taxPercents);
    params.append('PeriodFrom', periodFrom);
    params.append('PeriodTo', periodTo);
    params.append('Rent', totalRent);
    params.append('VatAmount', vat);
    params.append('TotalAmount', total);
    params.append('DecimalFormat', currencyPrecision?.decimalNumbers || 2);
    params.append('PaymentTermNoOfChqs', parseInt(value) || 2);
    params.append('IsEdit', false);
    params.append('PayId', '');
    params.append('CreatedBy', userName);
    params.append('STPercent', 0.0);
    params.append('RentFreeFrom', rentFreeFrom ?? '');
    params.append('RentFreeTo', rentFreeTo ?? '');
    const res = await apiService.getApiParamater('GET_PAYMENT_PLAN', `?${params?.toString()}`);
    const planData = res?.data?.result?.data;
    setInvoiceList(planData == null ? [] : planData);
  };
  return (
    <div className="p-3">
      <div className="d-flex mb-3">
        <div className="col-lg-8 nav nav-pills overslid d-flex gap-4">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            Transaction and Tenant
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
            Unit Details
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
            Additional Charges
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
            Payment Plan
          </div>
        </div>
        <div className="col-lg-4 d-flex gap-1">
          {loading === true ? (
            <div className="mainbtn flex-end gap-2 w-50">
              <ClipLoader color="#ffffff" className="mt-1" size={25} />
            </div>
          ) : (
            <div className="mainbtn flex-end gap-2 w-50" onClick={handleSave}>
              <FaSave color="#fff" className="center mt-1 mx-2" />
              <div className="center">Save</div>
            </div>
          )}
          <div className="mainbtnRed flex-end gap-2 w-50" onClick={handleclearform}>
            <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
            <div className="center">Reset</div>
          </div>
          <div className="mainbtnSecondary flex-end gap-2 w-50" onClick={() => navigate('/Property/Management/LeaseAgreement')}>
            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
            <div className="center">Back</div>
          </div>
        </div>
      </div>
      {gridVisibility[0] && (
        <div className="">
          <div className="cost-center-section mt-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setFilterTab(!FilterTab)}>
              <div className="h6 pt-1">Transaction Details</div>
            </div>
            <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                {loader === true ? (
                  <div className="center p-5">
                    <HashLoader color="#6e5199" />
                  </div>
                ) : (
                  <>
                  <div className="form-group grid-contain ">
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Transaction Date
                      </label>
                      <DatePicker
                        todayButton="Today"
                        selected={transData?.transectionDate}
                        onChange={(date) => handleInputChange({ name: 'transectionDate', value: date })}
                        dateFormat="dd-MMM-yyyy"
                        className="p-2 form-control w-100"
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="periodFrom" className="form-label pt-1 start">
                        Period From
                      </label>
                      <DatePicker
                        todayButton="Today"
                        selected={periodFrom}
                        onChange={(date) => handlePeriodFromChange({ name: 'periodFrom', value: date })}
                        dateFormat="dd-MMM-yyyy"
                        className="p-2 form-control w-100"
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="periodTo" className="form-label pt-1 start">
                        Period To
                      </label>
                      <DatePicker
                        todayButton="Today"
                        selected={periodTo}
                        onChange={(date) => handlePeriodToChange({ name: 'periodTo', value: date })}
                        dateFormat="dd-MMM-yyyy"
                        className="p-2 form-control w-100"
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="leaseTerm" className="form-label pt-1 start">
                        Lease Term
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="leaseTerm" value={leaseTerm} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        No. Of Installments
                      </label>
                      <input
                        type="number"
                        className="p-2 form-control w-75"
                        name="noInstallment"
                        min={1}
                        value={transData?.noInstallment}
                        onChange={handlefieldChange}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Select Remarks
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        value={transData.remarks}
                        options={remarksList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                        onChange={(selectedOption) => handleRemarksChange(selectedOption)}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Remarks
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="remarks2" onChange={handlefieldChange} value={transData?.remarks2} />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Arabic Remarks
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="arabicRemarks" onChange={handlefieldChange} value={transData?.arabicRemarks} />
                    </div>
                  </div>
                  <div className="form-group grid-contain mt-3">
                    <div className="d-flex">
                      <label htmlFor="rentFreeFrom" className="form-label pt-1 start">
                        Rent Free From
                      </label>
                      <DatePicker
                        todayButton="Today"
                        selected={rentFreeFrom}
                        onChange={(date) => handleRentFreeFromChange({ name: 'rentFreeFrom', value: date })}
                        dateFormat="dd-MMM-yyyy"
                        className="p-2 form-control w-100"
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="rentFreeTo" className="form-label pt-1 start">
                        Rent Free To
                      </label>
                      <DatePicker
                        todayButton="Today"
                        selected={rentFreeTo}
                        onChange={(date) => handleRentFreeToChange({ name: 'rentFreeTo', value: date })}
                        dateFormat="dd-MMM-yyyy"
                        className="p-2 form-control w-100"
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="rentFreeDays" className="form-label pt-1 start">
                        Rent Free Days
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        name="rentFreeDays"
                        value={rentFreeDays}
                        readOnly
                      />
                    </div>
                  </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="cost-center-section mt-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setTanantTab(!tentantTab)}>
              <div className="h6 pt-1">Tenant Primary Details</div>
            </div>
            <div className={`slide-content ${tentantTab ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${tentantTab ? 'slide-in' : 'slide-out'}`}>
                {loader === true ? (
                  <div className="center p-5">
                    <HashLoader color="#6e5199" />
                  </div>
                ) : (
                  <div className="form-group grid-contain ">
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Name
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        value={transData.CustomerName}
                        options={customerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                        onChange={(selectedOption) => handleCustomer(selectedOption)}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Acc/ Code
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        value={transData.CustomerAccount}
                        options={customerList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                        onChange={(selectedOption) => handleCustomerAccount(selectedOption)}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Contact No.
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.CustomerAccount?.value?.ContactNo} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Email
                      </label>
                      <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.CustomerAccount?.value?.Email} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Passport / ID
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="installments" value={transData?.CustomerAccount?.value?.IDNo} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Nationality
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.Nationality} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Vat Reg No
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.VATRegNo} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Leasing Agent
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        value={transData.leaseAgent}
                        options={leasingAgent?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                        onChange={(selectedOption) => handleAgentChange(selectedOption)}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="cost-center-section my-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setTanantJoint(!tentantJoint)}>
              <div className="h6 pt-1">Tenant Joint Details</div>
            </div>
            <div className={`slide-content ${tentantJoint ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${tentantJoint ? 'slide-in' : 'slide-out'}`}>
                {loader === true ? (
                  <div className="center p-5">
                    <HashLoader color="#6e5199" />
                  </div>
                ) : (
                  <div className="form-group grid-contain ">
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Name
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        value={transData.JointCustomerName}
                        options={customerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                        onChange={(selectedOption) => handleJointCustomer(selectedOption)}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Acc/ Code
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        value={transData.JointCustomerAccount}
                        options={customerList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                        onChange={(selectedOption) => handleJointCustomerAccount(selectedOption)}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Contact No.
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.JointCustomerAccount?.value?.ContactNo} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Email
                      </label>
                      <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.JointCustomerAccount?.value?.Email} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Passport / ID
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="installments" readOnly value={transData?.JointCustomerAccount?.value?.IDNo} />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Nationality
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        name="remarks"
                        value={transData?.JointCustomerAccount?.value?.Nationality}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Vat Reg No
                      </label>
                      <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.JointCustomerAccount?.value?.VATRegNo} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Broker
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        value={transData.Broker}
                        options={leasingAgent?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                        onChange={(selectedOption) => handleBrokerChange(selectedOption)}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {gridVisibility[1] && (
        <UnitDetailsEdt
          leaseData={leaseData}
          rentPerAnum={rentPerAnum}
          calculatedTotal={calculatedTotal}
          totalRent={totalRent}
          totalVat={totalVat}
          totalDiscount={totalDiscount}
          dataList={dataList}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          formData={formData}
          setFormData={setFormData}
          taxCodeList={taxCodeList}
          propertylist={propertylist}
          setAdditionalCharges={setAdditionalCharges}
          setUntData={setUntData}
          setDeletedUnit={setDeletedUnit}
          handleclearform={handleclearform}
          setDataList={setDataList}
          periodFrom={periodFrom}
          periodTo={periodTo}
          setEditIndex={setEditIndex}
          editIndex={editIndex}
          deletedUnit={deletedUnit}
          handleUnitPaymentPlan={handleUnitPaymentPlan}
          transData={transData}
          rentFreeDays={rentFreeDays}
          leaseTerm={leaseTerm}
          isKanooCompany={isKanooCompany}
        />
      )}
      {gridVisibility[2] && (
        <div className="table-container my-3" style={{ overflowX: 'auto', height: '700px' }}>
          <table>
            <thead className="dynoTable">
              <tr>
                <th>Select</th>
                <th>Description</th>
                <th>Rate</th>
                <th>Qty</th>
                <th>Amount</th>
                <th>Tax Code</th>
                <th>Vat</th>
                <th>Total</th>
                <th>Posting</th>
                <th>Remarks</th>
                <th>From Rent</th>
              </tr>
            </thead>
            <tbody>
              {additionalCharges?.map((row, index) => (
                <tr key={row.RecordId}>
                  {/* Select */}
                  <td className="m-0 p-0 text-center">
                    <div className="center mt-1">
                      <input
                        type="checkbox"
                        className="center"
                        checked={row.isSelected || false}
                        onChange={(e) => handleCheckboxChange(index, 'isSelected', e.target.checked)}
                        style={{ width: '20px', height: '20px' }}
                      />
                    </div>
                  </td>

                  {/* Description */}
                  <td className="m-0 p-0">
                    <input className="p-1" value={row.Description} disabled style={{ width: '400px' }} />
                  </td>

                  {/* Rate */}
                  <td className="m-0 p-0">
                    <input
                      className="p-1"
                      type="number"
                      onKeyDown={preventNegativeSign}
                      value={row.Rate || ''}
                      onChange={(e) => handleCheckboxChange(index, 'Rate', e.target.value)}
                      style={{ width: '100px' }}
                    />
                  </td>

                  {/* Qty */}
                  <td className="m-0 p-0">
                    <input
                      className="p-1"
                      onKeyDown={preventNegativeSign}
                      type="number"
                      value={row.Qty || ''}
                      onChange={(e) => handleCheckboxChange(index, 'Qty', e.target.value)}
                      style={{ width: '100px' }}
                    />
                  </td>

                  {/* Amount */}
                  <td className="m-0 p-0">
                    <input
                      className="p-1"
                      type="text"
                      value={row.Amount >= 0 ? row?.Amount?.toFixed(currencyPrecision?.decimalNumbers) : '0.000'}
                      disabled
                      style={{ width: '120px' }}
                    />
                  </td>

                  {/* Tax Code */}
                  <td className="m-0 p-0">
                    <select className="p-1" value={row.TaxCode ?? ''} onChange={(e) => handleVatChange(index, e.target.value)} style={{ width: '300px' }}>
                      <option value="">Select Tax Code</option>

                      {taxCodeList.map((tax) => (
                        <option key={tax.value} value={tax.value}>
                          {tax.text}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* Vat */}
                  <td className="m-0 p-0">
                    <input className="p-1" value={row.VAT?.toFixed(currencyPrecision?.decimalNumbers) || 0} disabled style={{ width: '100px' }} />
                  </td>

                  {/* Total */}
                  <td className="m-0 p-0">
                    <input className="p-1" value={row.Total?.toFixed(currencyPrecision?.decimalNumbers) || '0.00'} disabled style={{ width: '120px' }} />
                  </td>

                  {/* Posting */}
                  <td className="m-0 p-0 text-center">
                    <input
                      type="checkbox"
                      checked={row.Posting || false}
                      onChange={(e) => handleCheckboxChange(index, 'Posting', e.target.checked)}
                      style={{ width: '20px', height: '20px' }}
                    />
                  </td>

                  {/* Remarks */}
                  <td className="m-0 p-0">
                    <input
                      className="p-1"
                      value={row.Remarks || ''}
                      onChange={(e) => handleCheckboxChange(index, 'Remarks', e.target.value)}
                      style={{ width: '400px' }}
                    />
                  </td>

                  {/* From Rent */}
                  <td className="m-0 p-0 text-center">
                    <input
                      type="checkbox"
                      className="w-100"
                      checked={row.IsDeposit || false}
                      onChange={(e) => handleCheckboxChange(index, 'IsDeposit', e.target.checked)}
                      style={{ width: '20px', height: '20px' }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {gridVisibility[3] && <PaymentInvoices InvoiceList={InvoiceList} />}
    </div>
  );
};
export default EditLeaseAgrement;
